var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436 368.236V400H76v-31.764h44.646V179.412H76.708L256 40l179.291 139.412h-43.582v188.824H436Z",
    fill: "#36F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.783,
    cy: 261.229,
    rx: 107.92,
    ry: 107.497,
    fill: "#C8DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.593 291.632 18.426 10.757-7.073 12.234-18.613-10.567 3.536 21.502-13.958 2.224-5.399-32.995-14.518-8.344 3.537 32.071-26.056-19.095v16.686l25.871 21.135-8.934 10.936-16.937-13.717v21.319h-14.332v-21.319l-16.935 13.717-9.121-10.936 26.056-21.135v-16.686l-26.056 19.095 3.537-32.071-14.518 8.344-5.397 32.995-14.145-2.224 3.536-21.502-18.425 10.567-7.26-12.234 18.613-10.757-20.474-7.596 5.025-13.349 31.455 11.861 14.33-8.339-29.592-12.98 29.592-12.975-14.33-8.344-31.455 11.866-5.025-13.348 20.474-7.603-18.613-10.751 7.26-12.234 18.426 10.567-3.537-21.508 14.146-2.223 5.396 33 14.518 8.339-3.537-32.071 26.056 19.095v-16.687l-26.056-21.129 9.121-10.941 16.935 13.717V166.68h14.332v21.318l16.938-13.716 8.933 10.94-25.871 21.13v16.687l26.056-19.095-3.537 32.07 14.518-8.338 5.399-33.001 13.958 2.224-3.536 21.508 18.613-10.567 7.073 12.234-18.426 10.751 20.286 7.602-5.025 13.349-31.27-11.866-14.517 8.343 29.594 12.975-29.594 12.981 14.517 8.338 31.27-11.86 5.025 13.348-20.286 7.597Zm-51.742-3.522-2.047-19.095 17.494-7.786-17.494-7.787 2.047-19.094-15.636 11.492-15.446-11.492 2.048 19.094-17.682 7.787 17.682 7.786-2.048 19.095 15.446-11.493 15.636 11.493Z",
    fill: "#36F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412 512c55.228 0 100-44.772 100-100s-44.772-100-100-100-100 44.772-100 100 44.772 100 100 100Z",
    fill: "#91BBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.313 455.843v12.407H341.688v-12.407h17.441v-73.76h-17.165L412 327.625l70.035 54.458h-17.024v73.758l17.302.002Zm-34.603-63.282c-3.876-6.707-9.736-10.064-17.577-10.064-4.8 0-8.952 1.791-12.458 5.376-3.138 3.126-5.03 6.711-5.675 10.754-.553-4.043-2.4-7.628-5.536-10.754-3.6-3.585-7.798-5.376-12.595-5.376-7.844 0-13.703 3.355-17.577 10.064-2.77 4.78-3.925 10.339-3.462 16.681.46 7.079 2.423 13.122 5.883 18.13 3.459 5.012 8.097 9.537 13.91 13.58L412 454.463l19.378-13.511c5.812-4.043 10.45-8.57 13.911-13.58 3.458-5.008 5.418-11.051 5.881-18.13.46-6.342-.692-11.901-3.459-16.681h-.001Z",
    fill: "#36F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h512v512H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(312 312)",
    d: "M0 0h200v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.5458adc8186d25b456906191b50bef71.svg";
export { ForwardRef as ReactComponent };